import { NgModule } from '@angular/core';
import { NgbDropdownModule , NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {  } from '@ng-bootstrap/ng-bootstrap'; 

const bootstrapModules: any[] = [
    NgbDropdownModule ,
    NgbAccordionModule ,
    NgbModule
];

@NgModule({
    imports: bootstrapModules,
    exports: bootstrapModules
})

export class BootstrapModule { }